import { useState, useCallback } from 'react';

function usePopupState(onBlurCallback) {
    const [showPopup, setShowPopup] = useState(false);
    const onBlur = useCallback((event) => {
        var _a;
        if (event.relatedTarget !== event.currentTarget
            && !event.currentTarget.contains(event.relatedTarget)) {
            // se nascondo il popup subito e l'evento di destinazione conivolge il popup stesso
            // (tipo un click su un bottone nel popup)
            // l'evento di click non arriva ai componente in quanto già distrutti
            // a meno che non ci si trovi in un componente floating-ui
            if (!((_a = event.relatedTarget) === null || _a === void 0 ? void 0 : _a.closest('.floating-ui'))) {
                setTimeout(() => { setShowPopup(false); }, 300);
            }
            onBlurCallback(event);
        }
    }, [onBlurCallback]);
    return {
        showPopup, setShowPopup, onBlur,
    };
}

export { usePopupState as default };
